import React from 'react'
import MaterialSymbol from '../material-symbol'

const DateRange = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="date_range" {...props} />
))

DateRange.displayName = 'DateRange'

export default DateRange
